
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import ActivityCard from './components/activityCard.vue'
import TipsPopup from '@/components/tipsPopup/index.vue'
import {
  getMarketingActivityList,
  isOpenMembership
} from '@/api/marketActivity'
import { activityTypeList, periodTypeList, statusTypeList } from './index'

@Component({
  name: "MarketActivity",
  components: { ActivityCard, TipsPopup }
})
export default class marketActivity extends Vue {
  @Getter companyId!: string
  params = {
    pageIndex: 1,
    pageSize: 10,
    queryContent: '',
    categoryId: '',
    categoryType: '',
    activityType: '',
    periodType: '',
    statusType: ''
  }
  tempParams = {
    activityType: '',
    periodType: '',
    statusType: ''
  }
  showClassify = false
  classify = [
    {
      title: '活动类型',
      propName: 'activityType',
      options: activityTypeList
    },
    {
      title: '活动举办周期',
      propName: 'periodType',
      options: periodTypeList
    },
    {
      title: '活动状态',
      propName: 'statusType',
      options: statusTypeList
    }
  ]
  refreshing = false
  loading = false
  finished = false
  list = []
  total = 0
  listScrollTop = 0

  get classifyText() {
    const labels: string[] = []
    this.classify.forEach((item) => {
      const value = this.params[item.propName]
      const option = item.options.find((opt) => opt.value === value)
      labels.push(option?.label || '')
    })
    return labels.every((label) => label == '全部')
      ? '全部分类'
      : labels.join(' · ')
  }

  created() {
    this.getList()
  }

  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  onLoad() {
    this.params.pageIndex++
    this.getList()
  }

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  // 3. 缓存生命周期：页面激活（从详情页返回）时触发
  activated() {
    document.querySelector('.flex-scroll') && document.querySelector('.flex-scroll').scrollTo(0, this.listScrollTop)
  }

  getList() {
    getMarketingActivityList({
      storeId: this.companyId,
      ...this.params
    })
      .then((res) => {
        if (this.refreshing || this.params.pageIndex === 1) {
          this.list = []
          this.total = 0
        }
        this.list = this.list.concat(res.data.records)
        this.total = res.data.totalRecords
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      })
  }

  onSearch() {
    this.params.pageIndex = 1
    this.getList()
  }

  onConfirmSuccess() {
    this.onSearch()
  }

  onCreateActivity() {
    isOpenMembership({ storeId: this.companyId }).then((res: any) => {
      // 是否开启会员功能 1是 0否
      const { isOpenMembership = 0 } = res.data || {}
      if (Number(isOpenMembership) === 1) {
        this.$router.push('/selectTemplate')
      } else {
        ;(this.$refs.tipsPopupRef as any).showPopup()
      }
    })
  }

  onPopupOpen() {
    const { activityType, periodType, statusType } = this.params
    this.tempParams = {
      activityType,
      periodType,
      statusType
    }
    this.showClassify = true
  }

  selectOption(value, propName) {
    this.tempParams[propName] = value
  }

  onPopupClose() {
    this.showClassify = false
  }

  onPopupConfirm() {
    const { activityType, periodType, statusType } = this.tempParams
    this.params.activityType = activityType
    this.params.periodType = periodType
    this.params.statusType = statusType
    this.showClassify = false
    this.onSearch()
  }
}
